import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllUsers = createAsyncThunk(
  "user/getAllUsers",
  async ({ skip, limit, search, status }, { rejectWithValue }) => {
    try {
      const params = {};
      if (skip !== undefined) params.skip = skip;
      if (limit !== undefined) params.limit = limit;
      if (search) params.search = search;
      if (status) params.status = status;

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/users`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          response: {
            data: {
              message: "Network Error",
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || "An error occurred"
        );
      }
    }
  }
);

export const editUser = createAsyncThunk(
  "user/editUser",
  async (userData, { rejectWithValue }) => {
    try {
      
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      
      const body = JSON.stringify(userData);

      const response = await axios.put(
        `${PUBLIC_BASE_URL}/users/customer/change-status`,
        body,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred.");
      }
    }
  }
);

